import { useSnapShotQuery } from "@portal/queries/snapshot-query";
import { Col, Row } from "antd";
import { ActionArea } from "./ActionArea/ActionArea";
import { CurrentDueTile } from "./CurrentDue/CurrentDueTile";
import { InDisputeTile } from "./InDispute/InDisputeTile";
import { OverDueTile } from "./OverDue/OverDueTile";
import { PTPTile } from "./PTPTile/PTPTile";
import { RecentPayments } from "./RecentPayments/RecentPayments";
import { TotalOutstandingTile } from "./TotalOutstandingTile/TotalOutstandingTile";
import { TilesContainer } from "./style";

function Tiles() {
  const { data, isLoading } = useSnapShotQuery();
  const TotalOutstanding = (
    <TotalOutstandingTile loading={isLoading} data={data} />
  );
  const CurrentDue = <CurrentDueTile loading={isLoading} data={data} />;
  const InDispute = <InDisputeTile loading={isLoading} data={data} />;
  const Overdue = <OverDueTile loading={isLoading} data={data} />;
  const PTP = <PTPTile loading={isLoading} data={data} />;
  const RecentPayment = <RecentPayments loading={isLoading} data={data} />;

  return (
    <>
      <TilesContainer>
        <Row gutter={[28, 28]}>
          <Col span={24}>
            <ActionArea />
          </Col>
          <Col span={24}>
            <Row gutter={[24, 24]} wrap={false}>
              <Col flex="1">{TotalOutstanding}</Col>
              <Col flex="2">
                <Row gutter={[24, 12]}>
                  <Col span={12}>{CurrentDue}</Col>
                  <Col span={12}>{InDispute}</Col>
                  <Col span={12}>{Overdue}</Col>
                  <Col span={12}>{PTP}</Col>
                </Row>
              </Col>
              <Col flex="0 0 auto">{RecentPayment}</Col>
            </Row>
          </Col>
        </Row>
      </TilesContainer>
    </>
  );
}

export { Tiles };
